module.exports = __webpack_public_path__ + "img/CYP.6157cb2b.svg";